<template>
    <div>
        <div class="row pb-3">
            <div class="col-sm-12">
                <h4 class="font-weight-bold">
                    Histórico de participações no Serviço de Convivência e
                    Fortalecimento de Vínculos
                </h4>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <loading-animation
                    :active.sync="loading"
                    :is-full-page="false"
                    :opacity="1"
                    color="#5895FF"
                />
                <b-table
                    :fields="[
                        {
                            key: 'scfv_grupo',
                            label: $t('Detalhes'),
                        },
                        {
                            key: 'cadastrado',
                            label: $t('Vínculado'),
                        },
                        {
                            key: 'status',
                            label: $t('Status'),
                        },
                        {
                            key: 'actions',
                            label: '',
                            class: 'text-right',
                            thStyle: { width: '45px', minWidth: '45px' },
                        },
                    ]"
                    :items="itemList"
                    :responsive="true"
                    striped
                    hover
                    show-empty
                    small
                    outlined
                    stacked="md"
                    table-class="mb-3"
                >
                    <template v-slot:cell(scfv_grupo)="data">
                        Nome do Grupo:
                        <strong>
                            {{ data.value.nome_grupo }}
                            <b-link
                                :to="'/dashboard/scfv/edit/' + data.value.id"
                                target="_blank"
                            >
                                <i class="fas fa-external-link-alt"></i>
                            </b-link>
                        </strong>
                        <span
                            v-if="
                                data.item.situacao_prioritaria &&
                                data.item.situacao_prioritaria > 0
                            "
                        >
                            <br />
                            Situações Prioritárias:
                            <strong
                                v-html="data.item.situacao_prioritaria_nome"
                            >
                            </strong>
                        </span>
                    </template>
                    <template v-slot:cell(cadastrado)="data">
                        <strong>{{ data.value }}</strong>
                    </template>
                    <template v-slot:cell(status)="data">
                        <span v-html="data.item.status_nome"></span>
                    </template>

                    <template v-slot:cell()="data">
                        <b-button
                            :title="$t('Editar')"
                            :to="
                                '/dashboard/scfv/' +
                                data.item.scfv_grupo.id +
                                '/vinculo/' +
                                data.item.id +
                                '/edit'
                            "
                            class="px-2 mb-0"
                            size="xs"
                            type="button"
                            v-b-tooltip.hover
                            variant="success"
                            v-if="user_id == data.item.user_id"
                        >
                            <i class="mdi mdi-square-edit-outline" />
                        </b-button>

                        <!--
                        <b-button
                            :title="$t('Visualizar e Imprimir')"
                            :to="'/dashboard/scfvvinculo/show/' + data.item.id"
                            class="px-2 mb-0"
                            size="xs"
                            type="button"
                            v-b-tooltip.hover
                            variant="primary"
                            v-else
                        >
                            <i class="mdi mdi-eye" />
                        </b-button>
                        -->
                    </template>
                    <template v-slot:empty="scope">
                        <div class="text-center my-5">
                            <img
                                :alt="$t('No results')"
                                class="mb-5"
                                src="/img/icons/robot.svg"
                                style="max-height: 165px"
                            />
                            <h3 class="bold">{{ $t("No records found") }}</h3>
                        </div>
                    </template>
                </b-table>

                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-12">
                        <div class="form-group d-inline-flex mb-0">
                            <select
                                class="form-control"
                                style="width: 70px"
                                v-model="perPage"
                                v-on:change="getItens"
                            >
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                            </select>
                        </div>
                        <div class="d-inline-flex ml-2">
                            <b-pagination
                                :per-page="perPage"
                                :total-rows="pagination.total"
                                @change="changePage"
                                v-model="page"
                            />
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                        <div class="float-lg-right">
                            {{ $t("Showing page") }}
                            {{ pagination.currentPage }}
                            de
                            {{ pagination.totalPages }}
                            {{ $t("pages in") }}
                            {{ pagination.total }}
                            {{ $t("records") }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["item"],
    data() {
        return {
            page: 1,
            perPage: 10,
            loading: true,
            search: "",
            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0,
            },
            itemList: [],
        };
    },
    mounted() {
        this.getItens();
    },
    methods: {
        changePage(page) {
            if (
                page > 0 &&
                page <= this.pagination.totalPages &&
                page !== this.page
            ) {
                this.page = page;
                this.getItens();
            }
        },
        getItens() {
            this.loading = true;
            axios
                .get("api/dashboard/scfv", {
                    params: {
                        page: this.page,
                        search: this.search,
                        perPage: this.perPage,
                        usuarioId: this.item.id,
                    },
                })
                .then((response) => {
                    this.user_id = this.$store.state.user.id;
                    this.itemList = response.data.data;
                    this.pagination = response.data.pagination;
                    if (
                        this.pagination.totalPages < this.pagination.currentPage
                    ) {
                        this.page = this.pagination.totalPages;
                        this.getItens();
                    } else {
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
